/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../app/ng4-files/components/ng4-files-click/ng4-files-click.component';
import * as i2 from '../../../../../app/ng4-files/services/ng4-files.service';
import * as i3 from '../../../../../app/ng4-files/services/ng4-files-utils.service';
const styles_Ng4FilesClickComponent:any[] = ['.ng4-files-upload-btn[_ngcontent-%COMP%] { display: none; }'];
export const RenderType_Ng4FilesClickComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:0,
    styles:styles_Ng4FilesClickComponent,data:{}});
export function View_Ng4FilesClickComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(2,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),5,'label',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted(-1,(null as any),['\n  '])),i0.ɵncd((null as any),0),(_l()(),i0.ɵted(-1,
      (null as any),['\n  '])),(_l()(),i0.ɵeld(4,0,[['spyNg4FilesInputSpy',1]],(null as any),
      0,'input',[['class','ng4-files-upload-btn'],['type','file']],[[8,'multiple',
          0],[8,'accept',0]],[[(null as any),'change']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i1.Ng4FilesClickComponent = _v.component;
        if (('change' === en)) {
          _co.onChange(i0.ɵnov(_v,4).files);
          const pd_0:any = ((<any>(i0.ɵnov(_v,4).value = '')) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n'])),(_l()(),
      i0.ɵted(-1,(null as any),['\n']))],(null as any),(_ck,_v) => {
    var _co:i1.Ng4FilesClickComponent = _v.component;
    const currVal_0:any = (_co.maxFilesCount > 1);
    const currVal_1:any = i0.ɵinlineInterpolate(1,'',_co.acceptExtensions,'');
    _ck(_v,4,0,currVal_0,currVal_1);
  });
}
export function View_Ng4FilesClickComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'ng4-files-click',
      ([] as any[]),(null as any),(null as any),(null as any),View_Ng4FilesClickComponent_0,
      RenderType_Ng4FilesClickComponent)),i0.ɵdid(1,376832,(null as any),0,i1.Ng4FilesClickComponent,
      [i0.ChangeDetectorRef,i2.Ng4FilesService,i3.Ng4FilesUtilsService],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const Ng4FilesClickComponentNgFactory:i0.ComponentFactory<i1.Ng4FilesClickComponent> = i0.ɵccf('ng4-files-click',
    i1.Ng4FilesClickComponent,View_Ng4FilesClickComponent_Host_0,{configId:'configId'},
    {filesSelect:'filesSelect'},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvbmc0LWZpbGVzL2NvbXBvbmVudHMvbmc0LWZpbGVzLWNsaWNrL25nNC1maWxlcy1jbGljay5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvc2hhaXphci9Qcm9qZWN0cy9NQU1QVS9NeUdvdi9wb3J0YWwtZmUvc3JjL2FwcC9uZzQtZmlsZXMvY29tcG9uZW50cy9uZzQtZmlsZXMtY2xpY2svbmc0LWZpbGVzLWNsaWNrLmNvbXBvbmVudC50cyIsIm5nOi8vL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvbmc0LWZpbGVzL2NvbXBvbmVudHMvbmc0LWZpbGVzLWNsaWNrL25nNC1maWxlcy1jbGljay5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvbmc0LWZpbGVzL2NvbXBvbmVudHMvbmc0LWZpbGVzLWNsaWNrL25nNC1maWxlcy1jbGljay5jb21wb25lbnQudHMuTmc0RmlsZXNDbGlja0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxsYWJlbD5cbiAgPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PlxuICA8aW5wdXQgdHlwZT1cImZpbGVcIlxuICBjbGFzcz1cIm5nNC1maWxlcy11cGxvYWQtYnRuXCJcbiAgW211bHRpcGxlXT1cIm1heEZpbGVzQ291bnQgPiAxXCJcbiAgI3NweU5nNEZpbGVzSW5wdXRTcHlcbiAgYWNjZXB0PVwie3thY2NlcHRFeHRlbnNpb25zfX1cIlxuICAoY2hhbmdlKT1cIm9uQ2hhbmdlKHNweU5nNEZpbGVzSW5wdXRTcHkuZmlsZXMpOyBzcHlOZzRGaWxlc0lucHV0U3B5LnZhbHVlPScnXCIgLz5cbjwvbGFiZWw+XG4iLCI8bmc0LWZpbGVzLWNsaWNrPjwvbmc0LWZpbGVzLWNsaWNrPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQSx3RUFBTzthQUFBLG9DQUNMLGtCQUF5QjtNQUFBLHlCQUN6QjtNQUFBO1VBQUE7UUFBQTtRQUFBO1FBS0E7VUFBQTtVQUFBO1VBQUE7UUFBQTtRQUxBO01BQUEsZ0NBSytFLDBDQUN6RTthQUFBOztJQUpOO0lBRUE7SUFKQSxXQUVBLFVBRUEsU0FKQTs7OztvQkNGRjtNQUFBO3VDQUFBLFVBQUE7TUFBQTtNQUFBO0lBQUE7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/ng4-files/components/ng4-files-click/ng4-files-click.component.ngfactory.ts